import { createAction, props } from '@ngrx/store';
import { selectedRowData } from '../../shared/types/TableComponentState';
import { TransactionsTableColumn } from '../../shared/types/TransactionTableColumn';
import { ServiceErrorWithList } from '../models/shared/ServiceError';
import { DraftCommonWire } from '../models/wire/WireTemplatesResponse';
import { ServiceError } from '../models/shared/ServiceError';
import { ViewTypes, transactionstableTabName } from '../../shared/utilities/Constants';

export const gridReady = createAction(
  '[Create Request - Transactions Table] AG Grid Ready',
  props<{ gridReady: boolean, tab: transactionstableTabName }>()
)

export const refresh = createAction(
  '[Create Request - Transactions Table] Refresh Overview Data',
  props<{ accountId: string }>()
);

export const printClicked = createAction(
  '[Create Request - Transactions Table] User Requested Printout'
);

export const loadViewPage = createAction(
  '[Create Request - Transactions Table] Load View Page',
  props<{ viewType: ViewTypes }>()
);

export const editTransactionClicked = createAction(
  '[Edit Transaction] Edit Transaction link clicked from transactions table'
);

export const editInProgress = createAction(
  '[Edit Transaction] Edit in progress from transactions table'
);

export const cancelTransaction = createAction(
  '[Create Request - Transactions Table] Cancel Transaction',
  props<TransactionsTableColumn>()
)

export const cancelTransactionSuccess = createAction(
  '[Create Request - Transactions Table] Cancel Transaction Succeeded',
  props<{ cashieringRequestId: string}>()
)

export const cancelTransactionFailure = createAction(
  '[Create Request - Transactions Table] Cancel Transaction Failed',
  props<{ errorMsg: any }>()
)

export const setCurrentViewedTransaction = createAction(
  '[Create Request - Transactions Table] - Map cashiering transaction',
  props<{ transaction: TransactionsTableColumn }>()
)

export const setCurrentViewedTemplate = createAction(
  '[Create Request - Transactions Table] - Map template',
  props<{ template: DraftCommonWire | undefined }>()
)

export const resetSubmitCancelTransactionState = createAction(
  "[Create Request] - Reset SubmitCancelTransactionState to default"
)

export const cancelTransactionFailurePendingTransaction = createAction(
  '[Create Request - Transactions Table] Cancel Transaction Failed Pending Transaction',
  props<{ errorMsg: string}>()
);

export const currentTabUpdated = createAction(
  '[Transactions Table] User changed tab',
  props<{ currentTab: transactionstableTabName }>()
);

export const hasEmptyResponse = createAction(
  '[Transactions Table] Empty response for table'
);

export const editProfileClicked = createAction(
  '[Transactions Table] Edit Profile',
  props<{ rowData: selectedRowData }>()
);

export const addUpdateDeleteNicknameTemplates = createAction(
  '[Transactions Table] Add/Update/Delete nickname for templates from transaction table',
  props<{ draftId: string, nickName: string }>()
)

export const updateDraftSuccess = createAction(
  '[Transactions Table] Add/Update/Delete nickname for templates from transaction table successful',
  props<DraftCommonWire>()
)

export const updateDraftFailure = createAction(
  '[Transactions Table] Add/Update/Delete nickname for templates from transaction table failure',
  props<ServiceErrorWithList>()
)
export const startTransactionClicked = createAction(
  '[Create Request - Transactions Table] Start transaction clicked',
  props<{ draftId: string}>()
);

export const deleteTemplate = createAction(
  '[Create Request - Transactions Table] Delete Template',
  props<{ id: string }>()
)

export const deleteTemplateSuccess = createAction(
  '[Create Request - Transactions Table] Delete Template Succeeded'
)

export const deleteTemplateFailure = createAction(
  '[Create Request - Transactions Table] Delete Template Failed',
  props<ServiceError>()
)